<template>
  <input type="hidden" :name="name" :value="value">
</template>
<script>
export default {
  props: ["label", "type", "name", "value"]
}
</script>